import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import FancyToggle from '../elements/FancyToggle'
import InputRow from '../elements/InputRow'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'

const options = {
    postUrl: '/v1/voip/update-settings-bulk',
    showHideIcon: true,
    success: 'Success! Your VoIP settings have been successfully updated.'
}
const state = {}

class VoipSettingsForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        if (!this.props.values.serviceId) {
            this.props.setDynamicValues({
                serviceId: this.props.serviceId
            })
        }
    }

    handleFormSubmit (event) {
        event.preventDefault()
        const processedValues = Object.keys(this.props.values).reduce((acc, key) => {
            const value = this.props.values[key]
            if (typeof value === 'boolean') {
                acc[key] = value ? "1" : "0"
            } else if (typeof value === 'number' || key === 'serviceId') {
                acc[key] = value.toString()
            } else {
                acc[key] = value || ""
            }
            return acc;
        }, {});
        const customPostUrl = `${process.env.MIX_API_URL}v1/voip/${this.props.serviceId}/update-settings-bulk`
        this.props.handleSubmit(event, processedValues, customPostUrl)
    }

    render () {
        return (
            <form onSubmit={this.handleFormSubmit.bind(this)} onKeyDown={this.props.handleKeyDown}>
                <div className='mb-5'>
                    <div className='mb-2 text-right'>
                        <Button action={this.props.handleSubmit} title='Save' />
                    </div>

                    {this.props.children}

                    <h2 className='text-center text-md-left'>Call barring</h2>
                    <FancyToggle
                        title="Bar <span class='bold'>ALL outgoing</span> calls"
                        name='barOutgoingCalls'
                        value={this.props.values.barOutgoingCalls}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />
                    <FancyToggle
                        title="Bar <span class='bold'>ALL incoming</span> calls"
                        name='barIncomingCalls'
                        value={this.props.values.barIncomingCalls}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />
                    <FancyToggle
                        title="Bar <span class='bold'>ALL international</span> calls"
                        name='barInternationalCalls'
                        value={this.props.values.barInternationalCalls}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />
                    <FancyToggle
                        title="Bar <span class='bold'>ALL</span> calls to <span class='bold'>mobile numbers</span>"
                        name='barMobileCalls'
                        value={this.props.values.barMobileCalls}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />
                    <InputRow
                        label="Block <span class='bold'>unwanted calls from</span>"
                        name='blockCallsFrom'
                        value={this.props.values.blockCallsFrom}
                        errors={this.props.errors}
                        handleChange={this.props.handleInputChange}
                        placeholder='ie. 0290000000, 0400000000'
                    >
                        <small>(separate multiple numbers with a comma)</small>
                    </InputRow>
                </div>

                <div className='mb-5'>
                    <h2 className='text-center text-md-left'>Caller ID & voicemail</h2>
                    <FancyToggle
                        title="Display my <span class='bold'>caller ID</span>"
                        name='displayCallerId'
                        value={this.props.values.displayCallerId}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />
                    <FancyToggle
                        title="Enable my <span class='bold'>voicemail</span>"
                        name='enableVoicemail'
                        value={this.props.values.enableVoicemail}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                        numericValue={true}
                    />

                    {this.props.values.enableVoicemail
                        ? <React.Fragment>
                            <FancySelectAdvancedRow
                                label="Divert to <span class='bold'>voicemail after</span>"
                                name='divertToVoicemail'
                                value={this.props.values.divertToVoicemail}
                                errors={this.props.errors}
                                options={[
                                    { value: '5', label: '5 seconds' },
                                    { value: '10', label: '10 seconds' },
                                    { value: '15', label: '15 seconds' },
                                    { value: '30', label: '30 seconds' },
                                    { value: '45', label: '45 seconds' },
                                    { value: '60', label: '60 seconds' }
                                ]}
                                handleChange={this.props.setDynamicValues}
                            />
                            <InputRow
                                label="Forward <span class='bold'>voicemail</span> messages to <span class='bold'>my email</span>"
                                name='forwardVoicemailToEmail'
                                value={this.props.values.forwardVoicemailToEmail}
                                errors={this.props.errors}
                                handleChange={this.props.handleInputChange}
                                placeholder='Email address'
                            />
                            <InputRow
                                label="Send <span class='bold'>voicemail received</span> SMS alert to"
                                name='voicemailSmsAlert'
                                value={this.props.values.voicemailSmsAlert}
                                errors={this.props.errors}
                                handleChange={this.props.handleInputChange}
                                placeholder='Mobile phone number'
                            >
                                <small>(a charge of 8c per SMS applies)</small>
                            </InputRow>
                          </React.Fragment>
                        : ''}
                </div>

                <div className={`mb-3 ${this.props.values.enableVoicemail ? 'disabled' : ''}`}>
                    <h2 className='text-center text-md-left'>Call forwarding</h2>
                    {this.props.values.enableVoicemail ? <p className='p-0 text-center'>Not available when Voicemail is enabled.</p> : ''}
                    <FancyToggle
                        title="Enable <span class='bold'>call forwarding</span>"
                        name='callForwarding'
                        value={this.props.values.callForwarding}
                        errors={this.props.errors}
                        handleChange={this.props.values.enableVoicemail ? () => {} : this.props.setDynamicValues}
                        disabled={this.props.values.enableVoicemail}
                        numericValue={true}
                    />
                    {this.props.values.callForwarding
                        ? <InputRow
                            label='Forward my Home Phone calls to'
                            name='callForwardingNumber'
                            value={this.props.values.callForwardingNumber}
                            errors={this.props.errors}
                            handleChange={this.props.values.enableVoicemail ? () => {} : this.props.handleInputChange}
                            placeholder='Phone number'
                            disabled={this.props.values.enableVoicemail}
                        />
                        : ''}
                </div>

                {this.props.children}

                <div className='my-2 text-right'>
                    <Button action={this.handleFormSubmit.bind(this)} title='Save' />
                </div>
            </form>
        )
    }
}

export default FormHOC(VoipSettingsForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/VoipSettingsForm.js